"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyToSurveyCampaignMappingResponseToJSON = exports.SurveyToSurveyCampaignMappingResponseFromJSONTyped = exports.SurveyToSurveyCampaignMappingResponseFromJSON = exports.instanceOfSurveyToSurveyCampaignMappingResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the SurveyToSurveyCampaignMappingResponse interface.
 */
function instanceOfSurveyToSurveyCampaignMappingResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyToSurveyCampaignMappingResponse = instanceOfSurveyToSurveyCampaignMappingResponse;
function SurveyToSurveyCampaignMappingResponseFromJSON(json) {
    return SurveyToSurveyCampaignMappingResponseFromJSONTyped(json, false);
}
exports.SurveyToSurveyCampaignMappingResponseFromJSON = SurveyToSurveyCampaignMappingResponseFromJSON;
function SurveyToSurveyCampaignMappingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'surveyId': !(0, runtime_1.exists)(json, 'survey_id') ? undefined : json['survey_id'],
        'surveyCampaignId': !(0, runtime_1.exists)(json, 'survey_campaign_id') ? undefined : json['survey_campaign_id'],
    };
}
exports.SurveyToSurveyCampaignMappingResponseFromJSONTyped = SurveyToSurveyCampaignMappingResponseFromJSONTyped;
function SurveyToSurveyCampaignMappingResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'survey_id': value.surveyId,
        'survey_campaign_id': value.surveyCampaignId,
    };
}
exports.SurveyToSurveyCampaignMappingResponseToJSON = SurveyToSurveyCampaignMappingResponseToJSON;
